import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from '../core'
const WhiteLabelBanner = ({ classes }) => {
  return (
    <div className={classes.bannerContainer}>
      <div className={classes.bannerContent}>
        <Typography className={classes.bannerText}>
          Would you like to send custom emails from your domain?
        </Typography>
        <Typography className={classes.bannerDescription}>
          With a higher plan, you’ll be able to send branded emails using your
          own domain and enhance your professional image!
        </Typography>
        <CoreButton
          fullWidth
          onClick={() => {
            window.location.href = '/pricing'
          }}
        >
          See Plans & Upgrade
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(WhiteLabelBanner)
